"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3-time");
var Engine = require("@tableau/metrics-engine");
var moment = require("moment");
var metrics_engine_1 = require("@tableau/metrics-engine");
var Localize_1 = require("../../gen-src/Localize");
function formatRefreshedSince(date) {
    var fromDate = moment(date).fromNow();
    return Localize_1.Messages.refreshedSince({ fromDate: fromDate });
}
exports.formatRefreshedSince = formatRefreshedSince;
function formatLastUpdatedDate(date) {
    var day = moment(date).format('MMM D');
    var time = moment(date).format('h:mmA');
    return Localize_1.Messages.syncedAtTime({ day: day, time: time });
}
exports.formatLastUpdatedDate = formatLastUpdatedDate;
function formatLastModifiedDate(timestamp) {
    return moment(timestamp).format('MMM D, YYYY, h:mm A');
}
exports.formatLastModifiedDate = formatLastModifiedDate;
function formatSelectedDisplayDate(timestamp, dateTrunc) {
    switch (dateTrunc) {
        case metrics_engine_1.DateTrunc.SECOND: {
            return Localize_1.Formatters.wordyDateWithTimeToSecond(timestamp);
        }
        case metrics_engine_1.DateTrunc.MINUTE: {
            return Localize_1.Formatters.wordyDateWithTimeToMinute(timestamp);
        }
        case metrics_engine_1.DateTrunc.HOUR: {
            return Localize_1.Formatters.wordyDateWithTimeToHour(timestamp);
        }
        case metrics_engine_1.DateTrunc.ISO_WEEKDAY:
        case metrics_engine_1.DateTrunc.DAY: {
            return Localize_1.Formatters.wordyDate(timestamp);
        }
        case metrics_engine_1.DateTrunc.MONTH: {
            return Localize_1.Formatters.wordyMonthYear(timestamp);
        }
        case metrics_engine_1.DateTrunc.ISO_WEEK:
        case metrics_engine_1.DateTrunc.WEEK: {
            return Localize_1.Messages.weekOf({ date: Localize_1.Formatters.wordyDate(timestamp) });
        }
        case metrics_engine_1.DateTrunc.ISO_QTR:
        case metrics_engine_1.DateTrunc.QUARTER: {
            return Localize_1.Formatters.quarterYear(timestamp);
        }
        case metrics_engine_1.DateTrunc.ISO_YEAR:
        case metrics_engine_1.DateTrunc.YEAR: {
            return Localize_1.Formatters.year(timestamp);
        }
        case metrics_engine_1.DateTrunc.NONE:
        case metrics_engine_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return Localize_1.Formatters.wordyDateWithTimeToMinute(timestamp);
        }
    }
}
exports.formatSelectedDisplayDate = formatSelectedDisplayDate;
function formatDateForTooltip(timestamp, dateTrunc) {
    switch (dateTrunc) {
        case metrics_engine_1.DateTrunc.SECOND: {
            return Localize_1.Formatters.timeWithSeconds(timestamp);
        }
        case metrics_engine_1.DateTrunc.MINUTE: {
            return Localize_1.Formatters.dateWithTimeToMinute(timestamp);
        }
        case metrics_engine_1.DateTrunc.HOUR: {
            return Localize_1.Formatters.dateWithTimeToHour(timestamp);
        }
        case metrics_engine_1.DateTrunc.ISO_WEEKDAY:
        case metrics_engine_1.DateTrunc.DAY: {
            return Localize_1.Formatters.slashDate(timestamp);
        }
        case metrics_engine_1.DateTrunc.MONTH: {
            return Localize_1.Formatters.slashMonthYear(timestamp);
        }
        case metrics_engine_1.DateTrunc.ISO_WEEK:
        case metrics_engine_1.DateTrunc.WEEK: {
            return Localize_1.Messages.weekOf({ date: Localize_1.Formatters.slashDate(timestamp) });
        }
        case metrics_engine_1.DateTrunc.ISO_QTR:
        case metrics_engine_1.DateTrunc.QUARTER: {
            return Localize_1.Formatters.quarterYear(timestamp);
        }
        case metrics_engine_1.DateTrunc.ISO_YEAR:
        case metrics_engine_1.DateTrunc.YEAR: {
            return Localize_1.Formatters.year(timestamp);
        }
        case metrics_engine_1.DateTrunc.NONE:
        case metrics_engine_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return Localize_1.Formatters.dateWithTimeToMinute(timestamp);
        }
    }
}
exports.formatDateForTooltip = formatDateForTooltip;
function formatDataPointAsMetricNumber(value, formatString) {
    return formatValueAsMetricNumber(value !== undefined ? value.measure : undefined, formatString);
}
exports.formatDataPointAsMetricNumber = formatDataPointAsMetricNumber;
function formatValueAsMetricNumber(value, formatString) {
    return Engine.formatValueAsMetricNumber(value, formatString);
}
exports.formatValueAsMetricNumber = formatValueAsMetricNumber;
function dateTickFormat(date) {
    return (d3.timeMinute(date) < date
        ? Localize_1.Formatters.timeWithSeconds
        : d3.timeHour(date) < date
            ? Localize_1.Formatters.timeToMinute
            : d3.timeDay(date) < date
                ? Localize_1.Formatters.timeToHour
                : d3.timeMonth(date) < date
                    ? Localize_1.Formatters.monthAndDay
                    : d3.timeYear(date) < date
                        ? Localize_1.Formatters.month
                        : Localize_1.Formatters.year)(date);
}
exports.dateTickFormat = dateTickFormat;
//# sourceMappingURL=formatting.js.map